// NL
export const kitchenDefaultNL = {
  id: 'a90d7c11-d464-4afd-bad7-e509fcd65cfa',
  identifier: 'kitchen-default',
}
